export const SHOULD_SUBMIT_AFTER_SAVE_KEY = 'should_submit_after_save';

export const RECONCILIATION_PERIODIC_TYPE = 'periodic';

export const RECONCILIATION_ONE_TIME_TYPE = 'one_time';

export const REPEAT_SEND_DATETIMES = 'scheduled_reconciliations_dates';
